"use client";

import { useEffect } from "react";

import {
  LineChartIcon as ChartLineUp,
  Clock,
  Shield,
  Users,
  Headset,
  ArrowRight,
  CheckCircle,
} from "lucide-react";
import "./index.css";
import { ReadyToStart } from "../product-and-services";

export default function OSPLLanding() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
        }
      });
    }, observerOptions);

    document.querySelectorAll(".animate").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="ospl-container">
      <main>
        <section className="hero-section">
          <div className="hero-content">
            <div className="hero-text animate">
              <h1>
                ENTER THE WORLD OF
                <span className="gradient-text">{' '}PAKISTAN STOCK MARKET</span>
              </h1>
              <p className="hero-subtitle">
                With OSPL you can buy PSX Ltd and start investing towards your
                financial future
              </p>
              <div className="hero-buttons">
                <a href="/create-account" className="cta-button">
                  Start Trading Now
                  <ArrowRight size={20} />
                </a>
                <a href="/psx-investor-guide" className="demo-button">
                  Learn More
                </a>
              </div>
            </div>
            <div className="hero-image animate">
              <div className="laptop-container">
                <img
                  src="img/EDI-300x300.png"
                  alt="Trading Platform Interface"
                  width={600}
                  height={400}
                  className="laptop-screen"
                />
                <div className="reflection"></div>
              </div>
            </div>
          </div>
        </section>

        <section className="features-section">
          <div className="section-header animate">
            <h2>
              WHY CHOOSE <span className="gradient-text">OSPL?</span>
            </h2>
            <p>
              Experience the next generation of trading with our cutting-edge
              platform
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card animate">
              <div className="feature-icon">
                <ChartLineUp size={32} />
              </div>
              <h3>Real-time Market Data</h3>
              <p>
                Access to a powerful and dynamic watchlist with real-time
                fundamental data, technical analysis, research reports,
                consensus forecast
              </p>
            </div>

            <div className="feature-card animate">
              <div className="feature-icon">
                <Clock size={32} />
              </div>
              <h3>Real-time Trading</h3>
              <p>
                Real-time market news relating to corporate announcements and
                transfer of material information
              </p>
            </div>

            <div className="feature-card animate">
              <div className="feature-icon">
                <Shield size={32} />
              </div>
              <h3>Secure Platform</h3>
              <p>
                Bank-level security measures ensure your investments and
                personal information are protected
              </p>
            </div>

            <div className="feature-card animate">
              <div className="feature-icon">
                <Users size={32} />
              </div>
              <h3>Expert Support</h3>
              <p>
                Dedicated team of qualified equity analysts available for
                advising on technical research
              </p>
            </div>
          </div>

          <div className="benefits-list animate">
            <h3 className="benefits-title">✨ Additional Benefits</h3>
            <ul className="benefits-items">
              <li>
                <CheckCircle size={24} className="check-icon" />
                <span>
                  Exclusive <strong>WEBINAR</strong> Group for technical &
                  fundamental analysis
                </span>
              </li>
              <li>
                <CheckCircle size={24} className="check-icon" />
                <span>Real-time market news on corporate announcements</span>
              </li>
              <li>
                <CheckCircle size={24} className="check-icon" />
                <span>
                  Insights on key economic indicators like{" "}
                  <strong>interest rates</strong> &{" "}
                  <strong>fiscal policy</strong>
                </span>
              </li>
            </ul>
          </div>
        </section>

        <ReadyToStart />
      </main>
    </div>
  );
}
